import type { RootState } from 'tradera/state/configure-store';

export const selectCategory = (state: RootState) => state.views.syi.category;
